import React, { Component } from 'react';
import { Link } from 'react-router'

import {} from './ResearchArticle.css';

class ResearchArticle extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 Research Article";
        this.state = {
            item:this.props.location.state.item
        };
    
    }
    render() {
        return (
            <div className="container">
                <br/>
                <Link className="Article-research-link" to="/research">&lt; Back to Research</Link>
                <p className="title">{this.state.item.title}</p>
                <p className="subtitle">{this.state.item.journal}</p>
                <p className="subtitle">{this.state.item.authors}</p>
                <p>Keywords: {this.state.item.keywords}</p>
                <p>Original Article: <a className="Article-link" href={this.state.item.url} alt="Original Article" target="_blank">{this.state.item.url}</a></p>
                <hr/>
                <p>{this.state.item.abstract}</p>
                <br/>
                
            </div>
        );
    }
}

export default ResearchArticle;


// WEBPACK FOOTER //
// ./src/Research/ResearchArticle.js